module.exports = __webpack_public_path__ + "img/vod-event.a99ac70b.svg";